export default "__VITE_ASSET__3f4ef228__"